import { message, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../api/request.tsx";
import { toast } from "react-toastify";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";

const CreateOtp = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleCreateAccount = async () => {
    setLoading(true);
    const res = await apiClient.post(`otp/test-createOTP`, {
      phone,
    });

    if (res?.data?.status) {
      setPhone("");
      setLoading(false);
      messageApi.open({
        type: "success",
        content:
          `${res?.data?.message}, mã OTP là: ${res?.data?.data?.otp}` ||
          `Tạo mã OTP thành công, mã OTP là: ${res?.data?.data?.otp}`,
      });
    } else {
      setLoading(false);
      messageApi.open({
        type: "success",
        content: res?.data?.message || "Tạo mã OTP thất bại",
      });
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable = "md:font-semibold w-full text-[pink]";
  return (
    <div className="w-full">
      {contextHolder}
      <div className="text-2xl text-center text-[pink] font-bold">
        TẠO MÃ OTP
      </div>
      <div className="mb-3">
        <div className={classLable}>Số điện thoại (Ví dụ: 84363073476)</div>
        <input
          onChange={(value) => {
            setPhone(value.target.value);
          }}
          value={phone}
          type="text"
          className={classInput}
        />
      </div>
      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          onClick={() => {
            handleCreateAccount();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Tạo OTP"
          )}
        </button>
      </div>
    </div>
  );
};

export default CreateOtp;
